// extracted by mini-css-extract-plugin
export default {"input":"phone-setting_input__LZsig"};